import { render, staticRenderFns } from "./upgradeGetCardInfo.vue?vue&type=template&id=5cbf30ba&"
import script from "./upgradeGetCardInfo.vue?vue&type=script&lang=js&"
export * from "./upgradeGetCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./upgradeGetCardInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports